import { Field, Select } from '../common'
import { LegSearch } from '../leg-search'
import AiSuggestedBets from './AiSuggestedBets'
import BetSection from './BetSection'
import styles from './PostComposerWorkflow.module.css'

export default function MarketStep({
  isKambi,
  isCryptoDotCom,
  isOG,
  orgSlug,
  role,
  regulationMappings,
  searchOfferings,
  searchScope,
  query,
  onQueryChange,
  selectedOutcomeIds = [],
  onSelectKambiResult,
  betSectionProps,
  suggestedBetsProps,
  showHeader = true,
}) {
  return (
    <section
      className={styles.step}
      aria-labelledby={showHeader ? 'post-composer-market-heading' : undefined}
      aria-label={showHeader ? undefined : 'Bet editor'}
    >
      {showHeader ? (
        <header className={styles.stepHeader}>
          <p className={styles.stepEyebrow}>Step 2 of 3</p>
          <h2 id="post-composer-market-heading" tabIndex={-1}>Attach a bet</h2>
          <p>Optional. Add one selection for a straight bet or add multiple selections to build a parlay.</p>
        </header>
      ) : null}

      {isKambi ? (
        <>
          {suggestedBetsProps ? <AiSuggestedBets {...suggestedBetsProps} /> : null}
          <LegSearch
            context="feed"
            orgSlug={orgSlug}
            role={role}
            regulationMappings={regulationMappings}
            offerings={searchOfferings}
            // "1/1 regulations" says nothing: availability across the post's
            // regulations is checked when a bet is attached.
            coverage={searchScope ? searchScope.all : undefined}
            controls={searchScope?.options?.length ? (
              <Field label="Search in">
                <Select value={searchScope.value} onChange={(event) => searchScope.onChange(event.target.value)}>
                  {searchScope.options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
                </Select>
              </Field>
            ) : null}
            query={query}
            onQueryChange={onQueryChange}
            selectedIds={selectedOutcomeIds}
            onSelect={onSelectKambiResult}
            // Search can miss an outcome or be down; Kambi validation checks a
            // typed ID on the post's regulations without it.
            onAddOutcomeId={(id) => {
              if (!betSectionProps.outcomeIds.includes(id)) betSectionProps.onOutcomeIdsChange([...betSectionProps.outcomeIds, id])
            }}
          />
        </>
      ) : null}

      <BetSection
        {...betSectionProps}
        isKambi={isKambi}
        isCryptoDotCom={isCryptoDotCom}
        isOG={isOG}
        orgSlug={orgSlug}
        embedded
        hideOutcomeEntry={isKambi}
      />

    </section>
  )
}
